export default __webpack_public_path__ + "static/media/edit.56761393.svg";